import React, { memo, useCallback, useState } from 'react';
import { Keyboard, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import { hitSlopS, IconArrow, rem, Spacer } from 'design-system';
import IconTooltip from 'design-system/icons/IconTooltip';
import LogoBankAccount from 'design-system/LogoBankAccount';
import useStyles from 'hooks/useStyles';
import { getBalance } from 'utils/api/getBalance';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { formatAmount, formatSortCodeAndAccountNumber } from 'utils/formatting';
import { fundingAccountToolTipStrings } from '../constants';
import SelectFundingAccountModal from './SelectFundingAccountModal';
const BankAccountRow = ({ account, scrollValue, setFrom, onScroll }) => {
    const styles = useStyles(styleSet);
    const [primaryBalance] = getBalance(account);
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const onInfoButtonPress = useCallback(() => {
        Keyboard.dismiss();
        Modal.showConfirmation({
            title: fundingAccountToolTipStrings.fundingAccountTitle,
            subtitle: fundingAccountToolTipStrings.fundingAccountDesc,
            confirmButtonTitle: 'Okay',
        });
    }, []);
    const handleChooseOBAccount = useCallback(() => {
        Keyboard.dismiss();
        setIsPickerOpen(true);
        SelectFundingAccountModal.show({
            onSelected: (selectedAccount) => {
                setFrom(selectedAccount);
            },
            onScroll,
            scrollValue,
            selectedAccountId: account.id,
            onDidHideCallback: () => {
                setIsPickerOpen(false);
            },
        });
    }, [account.id, onScroll, scrollValue, setFrom]);
    return (<TouchableBounceCard onDark noMarginTop noMarginBottom style={styles.cardBtn} onPress={handleChooseOBAccount}>
      <View style={styles.row}>
        <View style={styles.iconContainer}>
          <LogoBankAccount size="R44" data={account}/>
        </View>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            {account.bankName || 'Linked bank'}
          </Text>
          <View style={styles.row}>
            {primaryBalance ? (<Text TextThin-14 Secondary>
                Available{' '}
                <Text NumbersThin-14 Secondary>
                  {formatAmount(primaryBalance.amount, primaryBalance.currency, 2)}
                </Text>
              </Text>) : (<Text TextThin-14 Secondary>
                {formatSortCodeAndAccountNumber(account.sortCode, account.accountNumber)}
              </Text>)}
            <Spacer w={4}/>
            <TouchableOpacity onPress={onInfoButtonPress} hitSlop={hitSlopS}>
              <IconTooltip colorKey="secondary" width={16} height={16}/>
            </TouchableOpacity>
          </View>
        </View>
        <IconArrow direction={isPickerOpen ? 'up' : 'down'}/>
      </View>
    </TouchableBounceCard>);
};
const styleSet = createStyleSheets((colors) => ({
    cardBtn: {
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    iconContainer: {
        width: rem(42),
        height: rem(42),
        borderWidth: rem(1),
        alignItems: 'center',
        borderRadius: rem(21),
        justifyContent: 'center',
        borderColor: colors.borders.logoStroke,
        backgroundColor: colors.background.contrast,
    },
    flex: {
        flex: 1,
    },
}));
export default memo(BankAccountRow);
